import React, { useEffect } from 'react';

import './garland.css';

const Garland = () => {
    return (
        <div id='garland-container'>
            <div className='b-page_newyear'>
                <div>
                    <i className='b-head-decor'>
                        <i className='b-head-decor__inner b-head-decor__inner_n1'>
                            <div className='b-ball b-ball_n1 b-ball_bounce' data-note='0'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n2 b-ball_bounce' data-note='1'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n3 b-ball_bounce' data-note='2'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n4 b-ball_bounce' data-note='3'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n5 b-ball_bounce' data-note='4'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n6 b-ball_bounce' data-note='5'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n7 b-ball_bounce' data-note='6'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n8 b-ball_bounce' data-note='7'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n9 b-ball_bounce' data-note='8'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i1'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i2'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i3'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i4'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i5'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i6'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                        </i>
                        <i className='b-head-decor__inner b-head-decor__inner_n2'>
                            <div className='b-ball b-ball_n1 b-ball_bounce' data-note='9'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n2 b-ball_bounce' data-note='10'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n3 b-ball_bounce' data-note='11'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n4 b-ball_bounce' data-note='12'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n5 b-ball_bounce' data-note='13'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n6 b-ball_bounce' data-note='14'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n7 b-ball_bounce' data-note='15'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n8 b-ball_bounce' data-note='16'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n9 b-ball_bounce' data-note='17'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i1'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i2'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i3'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i4'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i5'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i6'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                        </i>
                        <i className='b-head-decor__inner b-head-decor__inner_n3'>
                            <div className='b-ball b-ball_n1 b-ball_bounce' data-note='18'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n2 b-ball_bounce' data-note='19'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n3 b-ball_bounce' data-note='20'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n4 b-ball_bounce' data-note='21'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n5 b-ball_bounce' data-note='22'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n6 b-ball_bounce' data-note='23'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n7 b-ball_bounce' data-note='24'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n8 b-ball_bounce' data-note='25'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n9 b-ball_bounce' data-note='26'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i1'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i2'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i3'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i4'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i5'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i6'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                        </i>
                        <i className='b-head-decor__inner b-head-decor__inner_n4'>
                            <div className='b-ball b-ball_n1 b-ball_bounce' data-note='27'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n2 b-ball_bounce' data-note='28'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n3 b-ball_bounce' data-note='29'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n4 b-ball_bounce' data-note='30'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n5 b-ball_bounce' data-note='31'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n6 b-ball_bounce' data-note='32'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n7 b-ball_bounce' data-note='33'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n8 b-ball_bounce' data-note='34'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n9 b-ball_bounce' data-note='35'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i1'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i2'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i3'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i4'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i5'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i6'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                        </i>
                        <i className='b-head-decor__inner b-head-decor__inner_n5'>
                            <div className='b-ball b-ball_n1 b-ball_bounce' data-note='0'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n2 b-ball_bounce' data-note='1'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n3 b-ball_bounce' data-note='2'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n4 b-ball_bounce' data-note='3'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n5 b-ball_bounce' data-note='4'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n6 b-ball_bounce' data-note='5'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n7 b-ball_bounce' data-note='6'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n8 b-ball_bounce' data-note='7'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n9 b-ball_bounce' data-note='8'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i1'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i2'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i3'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i4'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i5'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i6'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                        </i>
                        <i className='b-head-decor__inner b-head-decor__inner_n6'>
                            <div className='b-ball b-ball_n1 b-ball_bounce' data-note='9'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n2 b-ball_bounce' data-note='10'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n3 b-ball_bounce' data-note='11'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n4 b-ball_bounce' data-note='12'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n5 b-ball_bounce' data-note='13'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n6 b-ball_bounce' data-note='14'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n7 b-ball_bounce' data-note='15'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n8 b-ball_bounce' data-note='16'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n9 b-ball_bounce' data-note='17'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i1'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i2'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i3'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i4'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i5'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i6'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                        </i>
                        <i className='b-head-decor__inner b-head-decor__inner_n7'>
                            <div className='b-ball b-ball_n1 b-ball_bounce' data-note='18'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n2 b-ball_bounce' data-note='19'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n3 b-ball_bounce' data-note='20'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n4 b-ball_bounce' data-note='21'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n5 b-ball_bounce' data-note='22'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n6 b-ball_bounce' data-note='23'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n7 b-ball_bounce' data-note='24'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n8 b-ball_bounce' data-note='25'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_n9 b-ball_bounce' data-note='26'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i1'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i2'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i3'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i4'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i5'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                            <div className='b-ball b-ball_i6'>
                                <div className='b-ball__right'></div>
                                <div className='b-ball__i'></div>
                            </div>
                        </i>
                    </i>
                </div>
            </div>
        </div>
    );
};

export default Garland;
